import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next/enablers/currentUserHasAccess';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';

export const canManageUploadAssetRequests = (): boolean => {
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	return currentUserHasAccess(PermissionName.CREATE_UPLOAD_REQUESTS);
};
